import { Autocomplete, Button, Checkbox, FormControlLabel, Grid, Paper, TextField } from '@mui/material'
import type { CatalogFilters as CatalogFiltersType } from './CatalogList.types'
import './CatalogList.css'

export interface CatalogFiltersProps {
  filters: CatalogFiltersType
  onFiltersChange: (filters: CatalogFiltersType) => void
  vehicleOptions: string[]
  contractTypeOptions: string[]
  setAsideOptions: string[]
}

export function CatalogFilters({
  filters,
  onFiltersChange,
  vehicleOptions,
  contractTypeOptions,
  setAsideOptions,
}: CatalogFiltersProps) {
  const updateFilter = (key: keyof CatalogFiltersType, value: string) => {
    onFiltersChange({ ...filters, [key]: value })
  }

  const handleClear = () => {
    onFiltersChange({
      contractVehicle: '',
      contractNumber: '',
      status: '',
      contractType: '',
      setAside: '',
    })
  }

  return (
    <Paper elevation={0} className="catalog-filters-paper">
      <form onSubmit={e => e.preventDefault()}>
        <Grid container spacing="16px" alignItems="center">
          <Grid size={2.5}>
            <Autocomplete
              options={vehicleOptions}
              value={filters.contractVehicle || null}
              onChange={(_e, newValue) => updateFilter('contractVehicle', newValue ?? '')}
              clearOnEscape
              renderInput={params => <TextField {...params} label="Contract Vehicle" size="small" fullWidth />}
            />
          </Grid>

          <Grid size={2}>
            <TextField
              fullWidth
              size="small"
              label="Contract #"
              value={filters.contractNumber}
              onChange={e => updateFilter('contractNumber', e.target.value)}
            />
          </Grid>

          <Grid size={2}>
            <Autocomplete
              options={contractTypeOptions}
              value={filters.contractType || null}
              onChange={(_e, newValue) => updateFilter('contractType', newValue ?? '')}
              clearOnEscape
              renderInput={params => <TextField {...params} label="Contract Type" size="small" fullWidth />}
            />
          </Grid>

          <Grid size={2}>
            <Autocomplete
              options={setAsideOptions}
              value={filters.setAside || null}
              onChange={(_e, newValue) => updateFilter('setAside', newValue ?? '')}
              clearOnEscape
              renderInput={params => <TextField {...params} label="Set Aside" size="small" fullWidth />}
            />
          </Grid>

          <Grid size="auto">
            <FormControlLabel
              label="Active"
              control={
                <Checkbox
                  size="small"
                  checked={filters.status === 'Active'}
                  onChange={e => updateFilter('status', e.target.checked ? 'Active' : '')}
                />
              }
            />
          </Grid>

          <Grid size="auto">
            <Button variant="outlined" onClick={handleClear}>
              CLEAR
            </Button>
          </Grid>

          <Grid size="auto">
            <Button variant="contained" type="submit">
              SEARCH
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  )
}
